// extracted by mini-css-extract-plugin
module.exports =  {"container":"handpicked_notice-module_container_d575f","avatar":"handpicked_notice-module_avatar_da8eb"};